import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import anchor from './anchor.js'

export default contract({
  anchor: array([
    anchor
  ])
})